module.exports = __webpack_public_path__ + "img/ttn-logo.512dc626.png";